import * as api from '../resources/manage-configurable-link.api';

const FETCH_CONFIGURABLE_LINK_REQUEST = 'FETCH_CONFIGURABLE_LINK_REQUEST';
const FETCH_CONFIGURABLE_LINK_SUCCESS = 'FETCH_CONFIGURABLE_LINK_SUCCESS';
const FETCH_CONFIGURABLE_LINK_FAILURE = 'FETCH_CONFIGURABLE_LINK_FAILURE';
const UPDATE_CONFIGURABLE_LINK_REQUEST = 'UPDATE_CONFIGURABLE_LINK_REQUEST';
const UPDATE_CONFIGURABLE_LINK_SUCCESS = 'UPDATE_CONFIGURABLE_LINK_SUCCESS';
const UPDATE_CONFIGURABLE_LINK_FAILURE = 'UPDATE_CONFIGURABLE_LINK_FAILURE';

export const fetchConfigurableLinkRequest = () => ({
  type: FETCH_CONFIGURABLE_LINK_REQUEST,
  isLoading: true,
});

export const fetchConfigurableLinkSuccess = (entries) => ({
  type: FETCH_CONFIGURABLE_LINK_SUCCESS,
  isLoading: false,
  entries,
});

export const fetchConfigurableLinkFailure = () => ({
  type: FETCH_CONFIGURABLE_LINK_FAILURE,
  isLoading: false,
});

export const fetchConfigurableLink = (locale) => async (dispatch) => {
  try {
    dispatch(fetchConfigurableLinkRequest());
    const entries = await api.fetchConfigurableLink(locale);
    if (entries) dispatch(fetchConfigurableLinkSuccess(entries));
  } catch (error) {
    console.error('FETCH_CONFIGURABLE_LINK', error);
    dispatch(fetchConfigurableLinkFailure());
  }
};

export const updateConfigurableLinkRequest = () => ({
  type: UPDATE_CONFIGURABLE_LINK_REQUEST,
});

export const updateConfigurableLinkSuccess = () => ({
  type: UPDATE_CONFIGURABLE_LINK_SUCCESS,
});

export const updateConfigurableLinkFailure = () => ({
  type: UPDATE_CONFIGURABLE_LINK_FAILURE,
});

export const updateConfigurableLink = (entries) => async (dispatch) => {
  try {
    dispatch(updateConfigurableLinkRequest());
    await api.updateConfigurableLink(entries);
    dispatch(updateConfigurableLinkSuccess());
    return true;
  } catch (error) {
    console.error('UPDATE_CONFIGURABLE_LINK', error);
    dispatch(updateConfigurableLinkFailure());
    return false;
  }
};

export default {
  FETCH_CONFIGURABLE_LINK_REQUEST,
  FETCH_CONFIGURABLE_LINK_SUCCESS,
  FETCH_CONFIGURABLE_LINK_FAILURE,
  UPDATE_CONFIGURABLE_LINK_REQUEST,
  UPDATE_CONFIGURABLE_LINK_SUCCESS,
  UPDATE_CONFIGURABLE_LINK_FAILURE,
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/manage-configurable-link.actions.js